import { Modal, Tabs } from 'antd';
import ZoneForm from './components/ZoneForm/ZoneForm';
import HfuBandsForm from './components/HfuBandsForm/HfuBandsForm';
import { isFlowUnitsEnabled } from '../../../../utils/env';

interface ZoneModalProps {
  isModalOpen: boolean;
  handleClose: () => void;
}

const ZoneModal = (props: ZoneModalProps) => {
  const items = [
    {
      key: 'zones',
      label: 'Rock Type Management',
      children: <ZoneForm handleClose={props.handleClose} />,
    },
    ...(isFlowUnitsEnabled()
      ? [
          {
            key: 'hfu',
            label: 'Flow Unit Bands',
            children: <HfuBandsForm />,
          },
        ]
      : []),
  ];

  return (
    <Modal
      title="Flow Unit Settings"
      open={props.isModalOpen}
      onCancel={props.handleClose}
      footer={null}
      width={560}
    >
      <Tabs defaultActiveKey="zones" items={items} />
    </Modal>
  );
};

export default ZoneModal;
